import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'

const fetchInfo = async () => {
  return await apiHelperService.get(`/api/individual/info`)
}
const initInfo = async () => {
  const formStore = useFormStore()
  const res = await fetchInfo()
  const {
    arabicFirstName,
    englishFirstName,
    arabicFatherName,
    englishFatherName,
    arabicGrandName,
    englishGrandName,
    arabicFourthName,
    englishFourthName
  } = res

  formStore.form.setValues({
    applicantArbFirstName: arabicFirstName,
    applicantEngFirstName: englishFirstName,
    applicantArbFatherName: arabicFatherName,
    applicantEngFatherName: englishFatherName,
    applicantArbThirdName: arabicGrandName,
    applicantEngThirdName: englishGrandName,
    applicantArbFourthName: arabicFourthName,
    applicantEngFourthName: englishFourthName
  })
}

export default async function () {
  const formStore = useFormStore()

  await initInfo()

  try {
    formStore.extraMap = {}
  } catch (error) {
    console.error('use595Preload', error)
  }
}
